import React from 'react';
const DropFiles = (props) => {
  return(
    <div className="drop-zone">
      Drag files here or
      <p>
        <button className="btn btn-primary">Upload</button>
      </p>
    </div>
  )
}
export default DropFiles;
